import Item from './Item.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

/** Vitamin / PP Up / PP Max. Display-only in bag; usage not implemented yet. */
export default class Vitamin extends Item {
    constructor({ id, name, description, price, overworldOptions, battleOptions } = {}) {
        const data = id ? globalItemDataStore[id] : {};
        super({
            id,
            name: name ?? data?.name,
            description: description ?? data?.description,
            price: price ?? data?.price,
            overworldOptions: overworldOptions ?? data?.overworldOptions ?? ['Use', 'Give', 'Cancel'],
            battleOptions: battleOptions ?? data?.battleOptions ?? ['Cancel'],
        });
    }
}
